import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset, change } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import { renderCheckBox, isValidNameWithSpace, renderDateField, renderAutoCompleteMultipleSelection, renderAutoCompleteSingleSelect, renderTextField, isInteger } from '../../../../../components/reduxFields';
import { getBehaviourGraphDCAction, getPatientBehaviorsReductionByPatientId } from '../actions/index';
import { getMasterData } from '../../DataCollection/BehaviorReductiom/Behavior/actions/behaviorActions';
// import { base64Decode } from '../../../../../actions/utilAction';
import BehaviourGraphComponent from './BehaviourGraph';
import TimeOfDayGraph from './TimeOfDayGraph';
import validate from './validate';

const duratinGraphType = [
    { id: 1, value: "Total Duration" },
    { id: 2, value: "Average Duration" },
    { id: 3, value: "Cumulative Duration" }
]

const frequencyGraphType = [
    { id: 1, value: "Standard" },
    { id: 2, value: "Cumulative" },
    //{ id: 3, value: "Time of day" }
]

const rateGraphType = [
    { id: 1, value: "Rate Per Minute" },
    { id: 2, value: "Rate Per 5 Minute" },
    { id: 3, value: "Rate Per 15 Minute" },
    { id: 4, value: "Rate Per 30 Minute" },
    { id: 5, value: "Rate Per Hour" },
    { id: 6, value: "Total Count" },
    { id: 7, value: "Total Duration" },
    { id: 8, value: "Average Duration" },
    //{ id: 9, value: "Time of day" }
]

const partialIntervalGraphType = [
    { id: 1, value: "% of Intervals" },
    //{ id: 2, value: "Time of day" }
]

const momentaryTimeSampleGraphType = [
    { id: 1, value: "% of Intervals" },
    //{ id: 2, value: "Time of day" }
]

class BehaviourGraphContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            patientId: props.patientId ? props.patientId : 0,
            masterPatientBehaviorsReductions: '',
            showGraph: '',
            xAxisName: null,
            yAxisName: null,
            yAxisMaxValue: null,
            disableYaxislabel: true,
            disableXaxislabel: true,
            disableLegend: true,
            hideGridlines: false,
            ShowdisplayAverage: true,
            displayAverage: false,
            selectedBehaviorsReduction: '',
            filteredMasterPatientBehaviorsReductions: [],
            recordingTypeName: null,
            graphTypeString: '',
            graphTitleString: '',            
            selectAllBehaviors: false,
            deSelectAllBehaviors: false,
            allBehaviors: [],
            displaySavedPhaseChangeLines: false,
            phaseChangeLineDataFlag : true,   
            displayPhaseChangeLinesCheckbox: true,
            isVisibleTrendCheckbox:false,
            showTrendChart: false,
        }
        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.setPhaselineState = this.setPhaselineState.bind(this);    
    }

    componentWillMount = () => {
        this.props.getPatientBehaviorsReductionByPatientId(this.state.patientId);
        const masterData = { masterdata: 'MASTERBEHAVIORCATEGORY,MASTERRECORDINGTYPES' };
        this.props.getMasterData(masterData);
    }


    handleNewRequest = (input, selectedRecord) => {
        let filteredValue = this.props.masterPatientBehaviorsReductions.filter(id => id.recordingTypeId === selectedRecord.value);
        input.onChange(selectedRecord.value);
        if (selectedRecord.label === "Duration") {
            this.setState({
                graphType: duratinGraphType
            });
            this.props.dispatch(change('BehaviourGraphContainerForm', 'graphTypeId', null));
        } else if (selectedRecord.label === "Frequency") {
            this.setState({
                graphType: frequencyGraphType
            });
            this.props.dispatch(change('BehaviourGraphContainerForm', 'graphTypeId', null));
        } else if (selectedRecord.label === "Rate") {
            this.setState({
                graphType: rateGraphType
            });
            this.props.dispatch(change('BehaviourGraphContainerForm', 'graphTypeId', null));
        } else if (selectedRecord.label === "Partial Interval") {
            this.setState({
                graphType: partialIntervalGraphType
            });
            this.props.dispatch(change('BehaviourGraphContainerForm', 'graphTypeId', null));
        } else if (selectedRecord.label === "Momentary Time Sample") {
            this.setState({
                graphType: momentaryTimeSampleGraphType
            });
            this.props.dispatch(change('BehaviourGraphContainerForm', 'graphTypeId', null));
        }        
        this.setState({
            filteredMasterPatientBehaviorsReductions: filteredValue,
            recordingTypeName: selectedRecord.label
        });
    }

    handleNewRequestGraphType = (input, selectedRecord) => {
        this.setState({
            showGraph: '',
        });
        input.onChange(selectedRecord.value);
        if (selectedRecord.label === 'Total Duration') {
            this.setState({
                graphTypeString: "TOTAL DURATION",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Total Duration (In Min)')));
        } else if (selectedRecord.label === 'Average Duration') {
            this.setState({
                graphTypeString: "AVERAGE DURATION",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Average Duration (In Min)')));
        } else if (selectedRecord.label === 'Cumulative Duration') {
            this.setState({
                graphTypeString: "CUMULATIVE DURATION",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Cumulative Duration (In Min)')));
        } else if (selectedRecord.label === 'Standard') {
            this.setState({
                graphTypeString: "STANDARD",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Standard Data')));
        } else if (selectedRecord.label === 'Cumulative') {
            this.setState({
                graphTypeString: "CUMULATIVE",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Cumulative Data')));
        } else if (selectedRecord.label === 'Time of day') {
            this.setState({
                graphTypeString: "TIME OF DAY",
                ShowdisplayAverage: false,
                displayAverage: false,
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Time of Day (in 24 hour)')));
        } else if (selectedRecord.label === 'Rate Per Minute') {
            this.setState({
                graphTypeString: "RATE PER MINUTE",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Rate Per Minute')));
        } else if (selectedRecord.label === 'Rate Per 5 Minute') {
            this.setState({
                graphTypeString: "RATE PER 5 MINUTE",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Rate Per 5 Minute')));
        } else if (selectedRecord.label === 'Rate Per 15 Minute') {
            this.setState({
                graphTypeString: "RATE PER 15 MINUTE",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Rate Per 15 Minute')));
        } else if (selectedRecord.label === 'Rate Per 30 Minute') {
            this.setState({
                graphTypeString: "RATE PER 30 MINUTE",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Rate Per 30 Minute')));
        } else if (selectedRecord.label === 'Rate Per Hour') {
            this.setState({
                graphTypeString: "RATE PER HOUR",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Rate Per Hour')));
        }
        else if (selectedRecord.label === 'Total Count') {
            this.setState({
                graphTypeString: "TOTAL COUNT",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', 'Total Count')));
        } else if (selectedRecord.label === '% of Intervals') {
            this.setState({
                graphTypeString: "PERCENTAGE OF INTERVALS",
                ShowdisplayAverage: true
            }, () => this.props.dispatch(change('BehaviourGraphContainerForm', 'YAxisName', '% of Intervals')));
        }
    }


    // onDateChange = (input, value) => {
    //     input.onChange(moment(value).format());
    //     this.setState({ [input.name]: value });
    // }

    onDateChange = (input, value) => {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value,
            displaySavedPhaseChangeLines: false,      
            phaseChangeLineDataFlag : true, }, () => { 
              this.props.dispatch(change('BehaviourGraphContainerForm', `displaySavedPhaseChangeLines`, false));    
            });
    }

    setPhaselineState(phaseChangeLineDataFlag) {          
        this.setState({
          phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
        });
      }

    dataAnalyticsSubmit = (event) => {
        let patientId = this.state.patientId;
        let behaviorsReductionId = event.behaviorsReductionId;
        let recordingTypeName = this.state.recordingTypeName;
        let graphTypeString = this.state.graphTypeString;
        if (patientId && behaviorsReductionId) {
            this.setState({
                showGraph: true,
                xAxisName: event.XAxisName,
                yAxisName: event.YAxisName,
                yAxisMaxValue: event.YAxisMaxValue,
                disableYaxislabel: event.disableYaxislabel === undefined ? this.state.disableYaxislabel : !event.disableYaxislabel,
                disableXaxislabel: event.disableXaxislabel === undefined ? this.state.disableXaxislabel : !event.disableXaxislabel,
                disableLegend: event.disableLegend === undefined ? this.state.disableLegend : !event.disableLegend,
                hideGridlines: event.hideGridlines === undefined ? this.state.hideGridlines : event.hideGridlines,
                displayAverage: event.displayAverage === undefined ? this.state.displayAverage : event.displayAverage,
                showTrendChart: event.showTrendChart === undefined ? this.state.showTrendChart : event.showTrendChart,
                graphTitleString: event.graphTitle,
                displaySavedPhaseChangeLines: event.displaySavedPhaseChangeLines === undefined ? this.state.displaySavedPhaseChangeLines : event.displaySavedPhaseChangeLines,
                phaseChangeLineDataFlag: this.state.displaySavedPhaseChangeLines,
                phaseChangeBaselineDataFlag: this.state.displayPhaseChangeLineForBaseline,
            });
        }

        let FromDate = event.FromDate ? moment(event.FromDate).format('YYYY-MM-DD') : moment(this.state.FromDate).format('YYYY-MM-DD');
        let ToDate = event.ToDate ? moment(event.ToDate).format('YYYY-MM-DD') : moment(this.state.ToDate).format('YYYY-MM-DD');
        this.setState({
            // FromDate: FromDate,
            // ToDate: ToDate,            
            behaviorsReductionId: behaviorsReductionId
        })
        this.props.getBehaviourGraphDCAction(patientId, behaviorsReductionId, FromDate, ToDate, recordingTypeName, graphTypeString);
    }

    handleReset = () => {
        this.props.dispatch(reset('BehaviourGraphContainerForm'));
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            showGraph: '',
        })
    }

    handleNewRequestMultiSelect = (input, selectedValues) => {
        input.onChange(selectedValues);
        this.setState({
            showGraph: '',
            selectedBehaviorsReduction: selectedValues.label,
        })
    }

    deselectAll = () => { //  Uncheck All Behaviors   
        let selectedBehaviors = [];
        this.props.dispatch(change('BehaviourGraphContainerForm', 'behaviorsReductionId', selectedBehaviors));         
        this.setState({ allBehaviors: [], selectedBehavior: [] }, () => {
          this.setState({ allBehaviors: [{ deselectAll: true }, ...this.state.filteredMasterPatientBehaviorsReductions], deSelectAllBehaviors: true, selectAllBehaviors: false, selectedBehavior: [] });
        });
    };
  
  selectAll = () => { //  Check All Behaviors 
        let selectedBehaviors = this.state.filteredMasterPatientBehaviorsReductions.map((obj) => obj.id);
        this.props.dispatch(change('BehaviourGraphContainerForm', 'behaviorsReductionId', selectedBehaviors));
        this.setState({ allBehaviors: [], selectedBehavior: [] }, () => {
          this.setState({ allBehaviors: this.state.filteredMasterPatientBehaviorsReductions, selectAllBehaviors: true, deSelectAllBehaviors: false, selectedBehavior: selectedBehaviors });
        });
    };

    checkDisable = (event, Id) => {   
        if(Id === 'displaySavedPhaseChangeLines')
        {
          this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
            phaseChangeLineDataFlag : true,        
          });      
        }         
      }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataAnalyticsSubmit)}>
                            <div className='row'>
                                <div className='col-sm-6 require mt-20'>
                                    <Field
                                        name="recordingTypeId"
                                        label="Recording Type"
                                        options={this.props.masterRecordingType}
                                        handleNewRequest={this.handleNewRequest}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <div className="row">
                                        <div className="col-sm-12">                                           
                                            <div className="sech_item_team">                     
                                                <span className={this.state.selectAllBehaviors ? 'active' : ''} onClick={this.selectAll.bind(this)}>( Select All Behaviors </span>
                                                <span className={this.state.deSelectAllBehaviors ? 'active' : ''} onClick={this.deselectAll.bind(this)}> Deselect All Behaviors ) </span>
                                            </div>                                           
                                        </div>
                                        <div className="col-sm-12 require">
                                            <Field
                                                name='behaviorsReductionId'
                                                // label="Behavior Name"
                                                options={this.state.filteredMasterPatientBehaviorsReductions}
                                                handleNewRequest={this.handleNewRequestMultiSelect}
                                                component={renderAutoCompleteMultipleSelection}
                                            />
                                        </div>
                                    </div>   
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-40 require">
                                    <Field
                                        name='graphTypeId'
                                        label="Graph Type"
                                        options={this.state.graphType}
                                        handleNewRequest={this.handleNewRequestGraphType}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="graphTitle"
                                        type="text"
                                        maxLength="100"
                                        label="Graph Title"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="XAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="X-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="YAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="Y-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        name="YAxisMaxValue"
                                        type="text"
                                        maxLength="4"
                                        label="Y-Axis Max Value"
                                        normalize={isInteger}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="disableLegend" 
                                        label="Disable Legends"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="hideGridlines" 
                                        label="Hide Gridlines"
                                        component={renderCheckBox} />
                                </div>    
                                {this.state.ShowdisplayAverage && <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displayAverage" 
                                        label="Display Average"                                       
                                        component={renderCheckBox} />
                                </div>}
                            </div>
                            <div className='row'>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="disableXaxislabel"
                                        label="Disable X Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-3 mt-10">
                                    <Field
                                        className="mt20 mb0"
                                        name="disableYaxislabel"
                                        label="Disable Y Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                {this.state.displayPhaseChangeLinesCheckbox &&
                                <div className="col-sm-3 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="displaySavedPhaseChangeLines" 
                                        label="Display saved phase change lines"
                                        onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                                        component={renderCheckBox} />
                                </div>}
                                <div className="col-sm-3 mt-10">
                                    <Field
                                    className="mt20 mb0" 
                                    name="showTrendChart"
                                    label="Display Trendlines"
                                    component={renderCheckBox}
                                    // onChange={(e) => console.log("e",e)}
                                    />
                                </div>
                            </div>                            
                            
                            <div className='row'>
                                <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter mt-20">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate Graph</RaisedButton>
                                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                </div>
                            </div>
                        </form>
                    </div>
                    {(this.state.showGraph !== '' && this.state.graphTypeString !== "TIME OF DAY") &&
                        <div>
                            {
                               this.props.dcSkillAcquisitionBatchGraph.loading === true
                                    ?
                                    <div className='row'>
                                        <div className="col-sm-12 text-center no-record" >Loading...</div>
                                    </div>
                                    :
                                    <BehaviourGraphComponent
                                        FromDate={this.state.FromDate}
                                        ToDate={this.state.ToDate}
                                        xAxisName={this.state.yAxisName}
                                        yAxisName={this.state.xAxisName}
                                        yAxisMaxValue={this.state.yAxisMaxValue}
                                        disableYaxislabel={this.state.disableYaxislabel}
                                        disableXaxislabel={this.state.disableXaxislabel}
                                        disableLegend={this.state.disableLegend}
                                        hideGridlines={this.state.hideGridlines}
                                        displayAverage={this.state.displayAverage}
                                        showTrendChart = {this.state.showTrendChart}
                                        selectedBehaviorsReduction={this.state.selectedBehaviorsReduction}
                                        graphTitle={this.state.graphTitleString || 'Behavior Name'}
                                        displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                                    />
                            }
                        </div>
                    }
                    {(this.state.showGraph !== '' && this.state.graphTypeString === "TIME OF DAY") &&
                        <div>
                        {
                            this.props.dcSkillAcquisitionBatchGraph.loading === true
                                ?
                                <div className='row'>
                                    <div className="col-sm-12 text-center no-record" >Loading...</div>
                                </div>
                                :
                                <TimeOfDayGraph
                                    FromDate={this.state.FromDate}
                                    ToDate={this.state.ToDate}
                                    xAxisName={this.state.yAxisName}
                                    yAxisName={this.state.xAxisName}
                                    yAxisMaxValue={this.state.yAxisMaxValue}
                                    disableYaxislabel={this.state.disableYaxislabel}
                                    disableXaxislabel={this.state.disableXaxislabel}            
                                    disableLegend={this.state.disableLegend}        
                                    hideGridlines={this.state.hideGridlines}                
                                    selectedBehaviorsReduction={this.state.selectedBehaviorsReduction}
                                    graphTitle={this.state.graphTitleString || 'Behavior Name'}
                                    displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                                />
                        }
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}

BehaviourGraphContainer = reduxForm({
    form: 'BehaviourGraphContainerForm',
    validate,
    enableReinitialize: true,
})(BehaviourGraphContainer);

function mapStateToProps(state) {
    let masterPatientBehaviorsReductions = [];

    if (state.dcSkillAcquisitionBatchGraph.behaviorsReductionsData) {
        masterPatientBehaviorsReductions = state.dcSkillAcquisitionBatchGraph.behaviorsReductionsData.data.PatientBehaviorsReduction || [];
    }
    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientBehaviorsReductions: masterPatientBehaviorsReductions,
        dcSkillAcquisitionBatchGraph: state.dcSkillAcquisitionBatchGraph,
        masterRecordingType: state.patient_behavior.masterData && state.patient_behavior.masterData.masterRecordingTypes,
    };
}

export default connect(mapStateToProps, { getPatientBehaviorsReductionByPatientId, getBehaviourGraphDCAction, getMasterData })(BehaviourGraphContainer);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/BehaviourGraph/index.js